import { Component, OnInit, Inject } from "@angular/core";
// import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
// import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
// import { IConfirm } from "src/app/interfaces/confirm";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
// import { ErrorsService } from "src/app/services/common/errors.service";
import { HttpHeaders } from "@angular/common/http";
import { CIDService } from "src/app/services/common/cid.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: 'app-course-list-for-move-student',
  templateUrl: './course-list-for-move-student.component.html',
  styleUrls: ['./course-list-for-move-student.component.css']
})
export class CourseListForMoveStudentComponent implements OnInit {

  param: any;
  errObject: any;
  //form: FormGroup;
  errors = new Array();

  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    this.translate.get("label.level"),
    "branch",
    this.translate.get("label.teacherName"),
    "date",
    this.translate.get("label.pattern"),
    this.translate.get("label.discount"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.room"),
    this.translate.get("label.status"),
    'function'
  ];

  constructor(
    // private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private courseService: CourseService,
    private registrationService: RegistrationService,
    public translate: TranslateService,
    public cidService: CIDService,
    private errorService: ErrorsService,
    private DialogRef: MatDialogRef<CourseListForMoveStudentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.list();
  }

  list() {
    let _data = this.data;
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.cidService.getCID()
      )
      .append(
        "BID",
        this.data.BranchEncryptId
      );

    let filter = {
      TermInfoId: this.data.TermInfoId,
      CourseTypeId: this.data.CourseTypeId,
      LevelInfoId: this.data.LevelInfoId,
      DiscountGroupId: this.data.DiscountGroupId,
      BranchEncryptId: this.data.BranchEncryptId
    };
    this.courseService.listByCompany(filter, 1, 1000, headers).subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList.filter(function (e) {
        debugger
        return e.Id != _data.CourseId
      });
    });
  }

  move(data: any) {

    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از انتقال دانشجو اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var command = {
          RegisterationId: this.data.RegistrationId,
          CourseId: data.Id
        };
        debugger;
        this.registrationService.moveStudentToOtherClass(command).subscribe(res => {
          if (res) {
            this.snackBar.OpenSnackBar(
              'دانشجو با موفقیت منتقل شد',
              "OK",
              5000,
              SoundEnum.beep
            );
            this.closeModal();
          }
          else {
            this.snackBar.OpenSnackBar(
              'خطا در انتقال دانشجو',
              "OK",
              5000,
              SoundEnum.beep
            );
          }
        }, err => {
          this.errObject = this.errorService.getError(err);
          this.param = this.errorService.objectError(this.errObject);
          this.errors = this.errorService.returnError(err);
        })
      }
    })
  }
  // createForm() {
  //   this.form = this.fb.group({
  //     StudentNationalCode: [this.data && this.data.StudentNationalCode ? this.data.StudentNationalCode : null],
  //     CourseId: [this.data && this.data.CourseId ? this.data.CourseId : null],
  //     CoursePatternId: [this.data && this.data.CoursePatternId ? this.data.CoursePatternId : null],
  //     TermInfoId: [this.data && this.data.TermInfoId ? this.data.TermInfoId : null],
  //     BranchEncryptId: [this.data && this.data.BranchEncryptId ? this.data.BranchEncryptId : null],
  //     Message: [null, Validators.compose([Validators.required])]
  //   });
  // }

  // submit(data: any) {
  //   console.log(data);
  //   let confirm: IConfirm = {
  //     accept: true,
  //     message: 'آیا از ارسال پیام پیام اطمینان دارید؟',
  //     alert: null,
  //     yesLabel: this.translate.get("label.yes"),
  //     noLabel: this.translate.get("label.no")
  //   };

  //   const dialogRef = this.dialog.open(ConfirmComponent, {
  //     width: "250px",
  //     data: confirm
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       if (data.StudentNationalCode) {
  //         let sendSMSCommand = {
  //           NationalCode: data.StudentNationalCode,
  //           Message: data.Message
  //         }
  //         this.courseService.SendSMSToPerson(sendSMSCommand).subscribe(() => {
  //           this.snackBar.OpenSnackBar(
  //             'پیام با موفقیت ارسال شد',
  //             "OK",
  //             5000,
  //             SoundEnum.beep
  //           );
  //         }, err => {
  //           this.errObject = this.errorService.getError(err);
  //           this.param = this.errorService.objectError(this.errObject);
  //           this.errors = this.errorService.returnError(err);
  //         })
  //       }
  //       else if (data.CourseId) {
  //         let sendSMSCommand = {
  //           CourseId: data.CourseId,
  //           Message: data.Message
  //         }
  //         this.courseService.SendSMSToClass(sendSMSCommand).subscribe(() => {
  //           this.snackBar.OpenSnackBar(
  //             'پیام با موفقیت ارسال شد',
  //             "OK",
  //             5000,
  //             SoundEnum.beep
  //           );
  //         }, err => {
  //           this.errObject = this.errorService.getError(err);
  //           this.param = this.errorService.objectError(this.errObject);
  //           this.errors = this.errorService.returnError(err);
  //         })
  //       }
  //       else if (data.CoursePatternId && data.TermInfoId && data.BranchEncryptId) {
  //         let sendSMSCommand = {
  //           CoursePatternId: data.CoursePatternId,
  //           BranchEncryptId: data.BranchEncryptId,
  //           TermInfoId: data.TermInfoId,
  //           Message: data.Message
  //         }
  //         this.courseService.SendSMSToPattern(sendSMSCommand).subscribe(() => {
  //           this.snackBar.OpenSnackBar(
  //             'پیام با موفقیت ارسال شد',
  //             "OK",
  //             5000,
  //             SoundEnum.beep
  //           );
  //         }, err => {
  //           this.errObject = this.errorService.getError(err);
  //           this.param = this.errorService.objectError(this.errObject);
  //           this.errors = this.errorService.returnError(err);
  //         })
  //       }
  //     }
  //   });
  // }

  closeModal() {
    this.DialogRef.close();
  }

}
